// components/SamplesUnavailableButton.jsx

import { useState } from "react";

export default function SamplesUnavailableButton({ supplierId }) {
    const [isVisible, setIsVisible] = useState(false);
    const [data, setData] = useState(null);

    const toggleOverlay = async () => {
        if (!supplierId) {
            alert("An error occurred while processing your request. Please contact the administrator.");
            return;
        }

        if (!isVisible) {
            try {
                const res = await fetch(`/api/product/samples-unavailable/${supplierId}`);
                if (res.status === 404) {
                    alert("Samples information not found for this supplier.");
                    return;
                }
                if (!res.ok) throw new Error("Failed to load");

                const json = await res.json();
                setData({
                    title: json.title ?? "Samples information not available",
                    text:
                        json.text ??
                        "Unfortunately, no information is available why this supplier does not offer samples.",
                    imageUrl: json.imageUrl,
                });
                setIsVisible(true);
            } catch (err) {
                console.error("Error loading samples info", err);
            }
        } else {
            setIsVisible(false);
        }
    };

    const closeOverlay = () => {      
      setIsVisible(false);
    }

    const handleBackgroundClick = (e) => {
        if (e.target.classList.contains("samples-overlay")) {
            closeOverlay();
        }
    };

    return (
        <>
            <button
                type="button"
                className="col-auto d-flex btn justify-content-center align-items-center btn-secondary gap-2 btn-primary-dark disabled"
                onClick={toggleOverlay}
            >
                <span>Samples unavailable</span>
            </button>

            {isVisible && data && (
                <div
                    className="overlay-with-box mobile-menu d-flex samples-overlay"
                    id={`samples-overlay-${supplierId}`}
                    onClick={handleBackgroundClick}
                >
                    <div className="overlay-box active-group flex-column pb-70 fit-content black mobile-menu-container sm-px-12 react-overlay">
                        <div className="width-550 sm-max-w-100">
                            <div className="row mb-54 sm-mb-24">
                                <div className="col">
                                    <h3 className="default-text" dangerouslySetInnerHTML={{__html: data.title}}></h3>
                                </div>
                                <div className="col-auto">
                                    <span
                                        className="curtains-icon curtains-icon-close size-24 pointer"
                                        onClick={closeOverlay}
                                    ></span>
                                </div>
                            </div>

                            <div className="body-text3" dangerouslySetInnerHTML={{__html: data.text}}></div>

                            {data.imageUrl && (
                                <img
                                    src={data.imageUrl}
                                    alt={data.title}
                                    className="mt-54 sm-mt-24"
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
